import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Restore from '@/views/Restore'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'login',
      path: '/',
      component: Login
    },
    {
      name: 'activate',
      path: '/activate/:id',
      component: Login
    },
    {
      name: 'register',
      path: '/register/:status(ready)?',
      component: Register,
      props: true
    },
    {
      name: 'restore',
      path: '/restore',
      component: Restore
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   next()
// })

export default router
